<template>
    <modal
        :name="name"
        transition="pop-out"
        :width="width"
        height="auto"
        scrollable
        :adaptive="true"
        @before-open="emitOpened"
        @closed="emitClosed"
    >
        <div class="tw:bg-white tw:rounded-xl tw:shadow-lg tw:border tw:border-gray-200">
            <div class="tw:border-b tw:border-gray-200 tw:px-6 tw:py-4">
                <div class="tw:flex tw:items-start tw:justify-between">
                    <div class="tw:flex-1">
                        <h2 class="tw:text-xl tw:font-semibold tw:text-gray-900">{{ title }}</h2>
                        <p v-if="subtitle" class="tw:text-sm tw:text-gray-500 tw:mt-1">{{ subtitle }}</p>
                    </div>
                    <button type="button" data-cy="modal-close" class="tw:text-gray-400 tw:hover:text-gray-600 tw:transition-colors tw:shrink-0 tw:ml-4" @click.prevent="close()">
                        <span class="tw:text-4xl tw:leading-none">×</span>
                    </button>
                </div>
            </div>

            <div class="tw:px-6 tw:py-6">
                <slot></slot>
            </div>

            <div v-if="$slots.footer" class="tw:border-t tw:border-gray-200 tw:px-6 tw:py-4 tw:text-right">
                <slot name="footer"></slot>
            </div>
        </div>
    </modal>
</template>

<script setup>
    import { getCurrentInstance } from 'vue'

    const props = defineProps({
        name: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        subtitle: {
            type: String,
            default: ''
        },
        width: {
            type: [Number, String],
            default: 800
        }
    });

    const emit = defineEmits(['close', 'opened', 'closed']);

    const instance = getCurrentInstance()

    const close = () => {
        instance.proxy.$modal.hide(props.name)
        emit('close');
    };

    const emitOpened = () => {
        emit('opened');
    };

    const emitClosed = () => {
        emit('closed');
    };
</script>

<style scoped>
    :deep(.v--modal) {
        border-radius: 0.75rem !important;
        overflow: visible !important;
    }
</style>
